
import stuinfo from './common/stuinfo'
import XHeader from 'vux/src/components/x-header/index.vue'

export default {
name: "pay-tuition",
components: {
XHeader,
stuinfo
},
data(){
return{
stuinfo:{
name:'小王',
gender:'男',
idcard:'12938475839204857394',
startyear:'2018',
department:'经济信息学院',
major:'建筑室内设计'
},
fee:[
{
feetype:'学费',
feenum:10000
},
{
feetype:'住宿费',
feenum:1800
},
],
loan:8000,
}
},
computed:{
need(){
var total = 0;
for(var i = 0;i<this.fee.length;i++){
total += this.fee[i].feenum;
}
return total-this.loan;
}
},
methods:{
gotopay(){
this.$router.push('/feepaid');
}
}
}



// WEBPACK FOOTER //
// ./src/components/PayTuition.vue